var i = Object.defineProperty, c = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var s = (r, e, a) => e in r ? i(r, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : r[e] = a, t = (r, e) => {
  for (var a in e || (e = {}))
    p.call(e, a) && s(r, a, e[a]);
  if (o)
    for (var a of o(e))
      d.call(e, a) && s(r, a, e[a]);
  return r;
}, m = (r, e) => c(r, f(e));
import l, { forwardRef as h } from "react";
import R from "../lib/SSRBase.mjs";
import n from "../defs/UserCircleDashed.mjs";
const w = h((r, e) => /* @__PURE__ */ l.createElement(R, m(t({ ref: e }, r), { weights: n })));
w.displayName = "UserCircleDashed";
export {
  w as UserCircleDashed
};
